export default __webpack_public_path__ + "static/media/appStoreBadgeUsBlack.0301d8fa.svg";